<template>
    <div class="panels-wrapper">
        <div class="left-wrapper" style="outline: none" tabindex="0">
            <InfoPanel
                class="info-panel"
                :isOpen="infoPanelOpen"
                :toggleInfoPanelOpen="toggleInfoPanelOpen"
                :toggleSettingsOpen="toggleSettingsOpen"
                sessionBrowserPage
                :openNewSessionModal="setNewSessionModalVisible"
            />
        </div>
        <slot></slot>
        <NewSessionModal
          :visible="newSessionModalVisible"
          :setVisible="setNewSessionModalVisible"
          :screenRecorderDisabled="screenRecorderDisabled"
        />
    </div>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue';
import InfoPanel from '../components/InfoPanel.vue';
import NewSessionModal from '../components/NewSessionModal.vue';

const infoPanelOpen = ref<boolean>(false),
      settingsShowMainMenu = ref<boolean>(true),
      activeSidePanel = ref<string | null>(null),
      PANEL_SETTINGS = ref<string>("SETTINGS"),
      newSessionModalVisible = ref<boolean>(false),
      screenRecorderDisabled = ref<boolean>(false),
      shouldCloseInfoPanel = ref<boolean>(false);

const settingsOpen = computed(
  () => activeSidePanel.value === PANEL_SETTINGS.value
);

function closeSettings() {
  if (shouldCloseInfoPanel.value) {
    infoPanelOpen.value = false;
  }
  activeSidePanel.value = null;
  settingsShowMainMenu.value = true;
}

function toggleSettingsOpen() {
  if (!settingsOpen.value) {
    if (!infoPanelOpen.value) {
      infoPanelOpen.value = true;
      shouldCloseInfoPanel.value = true;
    }
    activeSidePanel.value = PANEL_SETTINGS.value;
  } else {
    closeSettings();
  }
}

function toggleInfoPanelOpen() {
  infoPanelOpen.value = !infoPanelOpen.value;
  shouldCloseInfoPanel.value = false;
}

function setNewSessionModalVisible(visible: boolean) {
  newSessionModalVisible.value = visible;
}

</script>
<style lang="scss" scoped>
.left-wrapper {
  position: relative;

  .side-panel {
    background-color: map-get($component-colours, chat-background);
    color: map-get($component-colours, chat-font-primary);
    min-width: $side-panel-width;
    position: absolute;
    top: 0;
    left: 0;
    width: $side-panel-width;
    height: 100%;
    z-index: 2;

    @media only screen and (max-width: 1000px) {
      min-width: $side-panel-width-mobile;
      width: $side-panel-width-mobile;
    }

    ::selection {
      background-color: map-get(
        $component-colours,
        font-background-colour-highlighted
      );
    }
    ::-moz-selection {
      background-color: map-get(
        $component-colours,
        font-background-colour-highlighted
      );
    }
  }
}
</style>